export default function LatePaymentRemovalPage(props) {
  return (
    <div className="p-4 bg-zinc-800 rounded-lg text-center">
      <p className="text-zinc-400">LatePaymentRemovalPage Component</p>
      <p className="text-xs text-zinc-500">Placeholder - upload actual component file</p>
    </div>
  );
}
